import styled, { css } from 'styled-components';
import { RadioInput } from '@app/src/common/RadioInput';
import { FONTS, COLORS } from '@app/src/ui';

interface ListItem {
  showFirstItems?: number;
}
interface Item {
  activeSuggestion?: boolean;
}
export const ListOptions = styled.ul`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
  padding: 0;
  list-style: none;
  overflow-y: scroll;
  max-height: 215px;
  z-index: 1;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: ${COLORS.GRAY};
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: ${COLORS.GRAY_PLACEHOLDER};
  }
  &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: #fff;
  }
  ${(props: ListItem) => props.showFirstItems && css`
    max-height: ${props.showFirstItems * 44}px;
  `};
`;

export const RadioInputWrapper = styled(RadioInput)`
  display: flex;
  width: 100%;
  padding: 0 12px;
  min-height: 44px;
  justify-content: space-between;
  :hover {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  &:focus {
    background: aliceblue;
    color: ${COLORS.BLACK};
  }
  ${(props: Item) =>
    props.activeSuggestion &&
    css`
      background: aliceblue;
      color: ${COLORS.BLACK};
    `}; 
`;

export const ModalTitle = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 600;
  font-size: 14px;
  padding: 0 15px;
  line-height: 44px;
`;

export const Content = styled.div`
  background: #fff;
  min-width: 310px;
`;

export const LoaderWrapper = styled.span`
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const IconVignetteWrapper = styled.span`
  margin: 0 5px 0 11px;
`;

export const Name = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  color: #000;
  font-size: 19px;
  margin-right: auto;
  text-transform: uppercase;
  font-weight: 600;
`;